<script setup>
import { ref,onMounted,defineAsyncComponent, watch  } from 'vue'
import { useItineraryStore } from '@/stores/itinerary-stores.ts'
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import {readJSON} from '@/utils/fetch.js'; 
import {setCssColors} from '@/utils/setcsscolors.js';
import {createGoogleMapsLink,loadImageAsync} from '@/utils/helpers.js'; 
import SideBar from '@/components/SideBar.vue';
import QrCamera from '@/components/QrCamera.vue';
import Header from '@/components/Header.vue';
import { useI18n } from "vue-i18n";

import PoiCard from '@/components/PoiCard.vue';
import HorizontalBlocker from '@/components/HorizontalBlocker.vue';


import curPosMarkerImage from '@/assets/current-location-icon.png';

//import { read } from 'fs';

const windowWidth = window.innerWidth; 

const map = ref(null);
let loadFirst = [];
const showNavBar = ref(false);
const mapLoaded = ref(false);
let expressionMarkerPart = [];
const currentCoordinate = ref(false);
const { t, setLocaleMessage,locale  } = useI18n({ useScope: 'global' })

//const PopupComponent = defineAsyncComponent(() => import('@/components/PoiCard.vue'));


const maxIntitialZoom = 18;

var needBound = false;
var curPosMarker = false;

// konektane spremljivke
const sidebarRef = ref(null);


 

onMounted(() => {
  let parameter = window.location.search.substring(1);
  const VITE_DATA_URL = import.meta.env.VITE_DATA_URL;
  const VITE_MIZA_URL = import.meta.env.VITE_MIZA_URL;
  const VITE_DESTINATION_DATA_URL = import.meta.env.VITE_DESTINATION_DATA_URL;
  

  mapboxgl.accessToken = 'pk.eyJ1IjoiYXI5aXQiLCJhIjoiY2tzMDIzdDZoMWZ2bDJxczduMDJrcXVnYyJ9.cRFgHrdHVNT2-euD0Lgn0Q';
  useItineraryStore().map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/ar9it/ckzs0up43000b14pnrqjsi9ob',
    zoom: 12
  });

  if(mapLoaded.value == false) {
    useItineraryStore().map.on('load', () => {
      console.log("map loaded");
      mapLoaded.value = true;
      getLocation();
      setData();
    });
  }
  
  setCssColors();
  useItineraryStore().setItinerary();  
});

function getLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.watchPosition(showPosition);
  } else {
    console.log("--------spura  geokacije nemormo dobit")
    console.log("Geolocation is not supported  this browser.");
  }
}
async function showPosition(position) {
  const map = useItineraryStore().map; 
  currentCoordinate.value = [position.coords.longitude,position.coords.latitude];
  if (!curPosMarker) {
        // First time: create the marker
        curPosMarker = true;
        console.log("--------spura  postavlmao curlocmarkert")
        let image = await loadImageAsync(useItineraryStore().map, curPosMarkerImage);
        map.addImage('curLocationDr', image);
        map.addSource('user-location', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });

        // Add the symbol layer using the image
        map.addLayer({
            id: 'user-location-layer',
            type: 'symbol',
            source: 'user-location',
            layout: {
                'icon-image': 'curLocationDr',
                'icon-size': 0.20 // Adjust size if needed
            }
        });


        /*
        const el = document.createElement('div');
        el.className = 'custom-marker';
        el.style.backgroundImage = curPosMarkerImage; // Replace with your image
        el.style.width = '40px';
        el.style.height = '40px';
        el.style.backgroundSize = 'cover';


        curPosMarker = new mapboxgl.Marker(el)
            .setLngLat(currentCoordinate.value)
            .addTo(useItineraryStore().map);

        */


  } else {
        // Update marker position
        //curPosMarker.setLngLat(currentCoordinate.value);
        console.log("--------spura  pupdejtamo curlocmarkert")
        if (map.getSource('user-location')) {
        map.getSource('user-location').setData({
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: currentCoordinate
                    }
                }
            ]
        });
      }
  }
  
  console.log("--------spura   dobili geolokacijo needBound:"+needBound)

  if(useItineraryStore().selectedPath != '' && needBound) setMap()
  

}

async function setData() {
  console.log("setData");
  console.log("--------spura   setData ")
  //debugger;
  const VITE_DESTINATION_DATA_URL = import.meta.env.VITE_DESTINATION_DATA_URL;
  loadFirst = [];
  let allKeys = Object.keys(useItineraryStore().itinerary);
  if(allKeys.length == 0) {
    useItineraryStore().map.setCenter(['14.5058', '46.0569']);
    useItineraryStore().map.setZoom(12);
    //useItineraryStore().setCategories();
    return;

  }
  useItineraryStore().allKeys = allKeys;
  let selectedPath = allKeys[useItineraryStore().selectedPathNumber];
  useItineraryStore().allPathsNumber = allKeys.length;
  useItineraryStore().selectedPath = selectedPath;
 
  if(useItineraryStore().itinerary[selectedPath].options.destination == useItineraryStore().currentDestination) {
    
    useItineraryStore().itinerary[selectedPath].pois.forEach((poi) => {
      let category = poi.properties.categories[0] + '-' + poi.properties.categories[1];
      loadFirst.push(category);
    });
  }else {
    useItineraryStore().currentDestination = useItineraryStore().itinerary[selectedPath].options.destination;

    // Load the initial options.json
    const optionsResult = await readJSONAsync(VITE_DESTINATION_DATA_URL + useItineraryStore().currentDestination + '/options.json');
    useItineraryStore().options = JSON.parse(optionsResult);


    readJSON(VITE_DESTINATION_DATA_URL + useItineraryStore().currentDestination +'/selectors.json',function (result){
      let jsonObject = JSON.parse(result);
      useItineraryStore().selectors = jsonObject;
      if(useItineraryStore().markersImages.size == 0) {
        useItineraryStore().setCategories();
      }
      
    });

    useItineraryStore().itinerary[selectedPath].pois.forEach((poi) => {
      let category = poi.properties.categories[0] + '-' + poi.properties.categories[1];
      loadFirst.push(category);
    });
    
    setMap();
    setLocalization(useItineraryStore().itinerary[selectedPath].options.lang);
  }
}


async function setLocalization(lang) {
  console.log("--------spura   setamo localization start "+lang)
  const VITE_DESTINATION_DATA_URL = import.meta.env.VITE_DESTINATION_DATA_URL;
  let defaultLanguage = useItineraryStore().options.languages[0] // or a specific logic to determine the default language
  if(lang != undefined) defaultLanguage = lang;
  useItineraryStore().selectedLanguage = defaultLanguage;
  useItineraryStore().allLanguages = useItineraryStore().options.languages;
  locale.value = defaultLanguage // Update the default language

  // Create an array of promises for loading each language file
  const languagePromises = useItineraryStore().options.languages.map(language =>
  Promise.all([
    readJSONAsync(VITE_DESTINATION_DATA_URL + 'common/i18n/' + language + '.json'),
    readJSONAsync(VITE_DESTINATION_DATA_URL + useItineraryStore().currentDestination + '/locale_poi-' + language + '.json')
  ])
);

  // Wait for all language files to be loaded
  const languagesData = await Promise.all(languagePromises);
  console.log("--------spura   dobili lokalizacijske podatke"+defaultLanguage)

  // Optionally, process the results (e.g., setting locale messages)
  languagesData.forEach(([i18nData, poiData], index) => {
    const language = useItineraryStore().options.languages[index];
    const i18nJson = JSON.parse(i18nData);
    const poiJson = JSON.parse(poiData);
    const combinedData = { ...i18nJson, ...poiJson };
    setLocaleMessage(language, combinedData);
    console.log("combinedData", combinedData)
  });
}


function setMap() {
  //debugger;
  needBound = true
  console.log("useItineraryStore().itinerary", useItineraryStore().itinerary);

  let lng = useItineraryStore().itinerary[useItineraryStore().selectedPath].pois[0].geometry.coordinates[0];
  let lat = useItineraryStore().itinerary[useItineraryStore().selectedPath].pois[0].geometry.coordinates[1];
  
  let coords = [];
  for (const poi of useItineraryStore().itinerary[useItineraryStore().selectedPath].pois) {
    coords.push({lng: poi.geometry.coordinates[0], lat: poi.geometry.coordinates[1]})
  }
  setBoundBox(lng, lat, coords)
  //useItineraryStore().map.setCenter([lng, lat]);
  //useItineraryStore().map.setZoom(12);
}

function setBoundBox(lng, lat, coords){
  useItineraryStore().map.setCenter([lng, lat]);
  let bounds =  new mapboxgl.LngLatBounds(
        [lng, lat],
        [lng, lat]  
  );
  console.log(coords)    
  for (const coord of coords) {
        bounds.extend(coord);
        //console.log("kurac", coord)
  }
  
  if(currentCoordinate.value != false){
    console.log("--------setamo bounding box z lokacijo")
    bounds.extend({lng: currentCoordinate.value[0] + "", lat: currentCoordinate.value[1] + ""});
    //console.log("kurac2", {lng: currentCoordinate.value[0] + "", lat: currentCoordinate.value[1] + ""})
    needBound = false
  }else 
    console.log("--------setamo bounding box brez lokacije")
  
  useItineraryStore().map.fitBounds(bounds, { padding: 150, animate: false });
  const curZoom = useItineraryStore().map.getZoom();
  if(curZoom > maxIntitialZoom){
    useItineraryStore().map.setZoom(maxIntitialZoom); 
  }
}

const loadMapMarkersAndLayers = async () => {
  try {
    addMarkerLayer();
    loadMarkersToMap(loadFirst).then(() => {
      showPath();
    });
  } catch (error) {
    console.error('Error loading map markers', error);
  }
};

async function loadMarkersToMap(markers) {
  for(let i = 0; i < markers.length; i++) {
      if(!useItineraryStore().map.hasImage('image-marker-' + loadFirst[i])) {
        let imageMarker = useItineraryStore().markersImages.get(loadFirst[i]);
        if(imageMarker == undefined) {
          imageMarker = useItineraryStore().markersImages.get('empty-marker');
        }
      
        let image = await loadImageAsync(useItineraryStore().map, imageMarker);
        useItineraryStore().map.addImage('image-marker-' + loadFirst[i], image);
      }
    }
}

const addMarkerLayer = () => {
  if (useItineraryStore().expressionMarkerPart.length > 1) {
    useItineraryStore().expressionMarkerPart.push('default-marker');
  } else {
    useItineraryStore().expressionMarkerPart = 'default-marker'
  }

  let layout = {}; 
  if(useItineraryStore().expressionMarkerPart == 'default-marker') {
    layout = {
        'icon-size': returnMarkerScale(0.1,0.8),
        'text-offset': [0, 1],
        'text-anchor': 'bottom',
        'icon-anchor': 'bottom',
        "icon-allow-overlap": true,  // Allow icons to overlap with each other
        "icon-ignore-placement": true  // Ignore the placement of other icons when placing a particular icon
    }
  }else {
    layout = {
        'icon-image': [
          'case',
          ...useItineraryStore().expressionMarkerPart
        ],
        'icon-size': returnMarkerScale(0.1,0.8),
        'text-offset': [0, 1],
        'text-anchor': 'bottom',
        'icon-anchor': 'bottom',
        "icon-allow-overlap": true,  // Allow icons to overlap with each other
        "icon-ignore-placement": true  // Ignore the placement of other icons when placing a particular icon
    }
  }
  console.log("marker layour added AND EXPRESSION");
    useItineraryStore().map.addLayer({
        id: 'markers',
        type: 'symbol',
        source: 'clustering',
        filter: ['!', ['has', 'point_count']], // Filter for individual markers (not clusters)
        layout: layout,
        paint: {
          'icon-opacity': ['get', 'opacity']
        }
      });

    useItineraryStore().map.on('click', 'markers', function (e) {
        const { id: clickedFeatureId } = e.features[0].properties;
        /*if (useItineraryStore().activePoi == clickedFeatureId) {
          closePoiPresentation(); 
          return;
        }*/
        console.log("click", e.features[0].properties)
        useItineraryStore().activePoiProperties = e.features[0].properties;
        useItineraryStore().activePoi = clickedFeatureId;
        console.log('sidebarRef.value.navToggle', sidebarRef.value.navToggle)
        sidebarRef.value.navToggle = false;
        console.log('sidebarRef.value.navToggle', sidebarRef.value.navToggle)
      });
  

};

function showPath() {
    let pathColor = "#4CC8CD";
    console.log('show path');
    let id = 'path_' + useItineraryStore().selectedPath;
    let coordinates = "";
    let selectedPathData = useItineraryStore().itinerary[useItineraryStore().selectedPath];

    coordinates = selectedPathData.route.geometry;
    let path = useItineraryStore().map.addLayer({
        id: id,
        type: 'line',
        source: {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {},
                geometry: coordinates,
            }
        },
        layout: {
            'line-join': 'round',
            'line-cap': 'round'
        },
        paint: {
            'line-width': 3,
            'line-color': pathColor
        }
    });
    //return id;

    //drejc - setamo tip poti (path, single ali list)
    let pathKey = useItineraryStore().selectedPath;
    let travelmode = 'walking';
    let hyphenIndex = pathKey.indexOf("-");
    let pathtype = false; 

    if (hyphenIndex !== -1) { //
                let travelmodeCandidate = pathKey.substring(0, hyphenIndex);
                if(travelmodeCandidate == 'poi'){
                    useItineraryStore().type = 'single';
                    let remain = pathKey.substring(hyphenIndex+1);
                    hyphenIndex = remain.indexOf("-");
                    if (hyphenIndex !== -1){
                        travelmode = remain.substring(0, hyphenIndex);
                    }
                } else if (travelmodeCandidate == 'path'){
                    useItineraryStore().type = 'path';
                    travelmode = false;
                }
                else {
                  travelmode = travelmodeCandidate;
                  useItineraryStore().type = 'list';
                }
            }
    if(travelmode === false){
      useItineraryStore().showNavigation = false;
    }else{
      useItineraryStore().showNavigation = true;
      useItineraryStore().travelMode = travelmode;
    } 
    /*hyphenIndex !== -1) pathtype = useItineraryStore().selectedPath.substring(0, hyphenIndex);
    if(pathtype == 'path') useItineraryStore().showNavigation = false;
    else useItineraryStore().showNavigation = true;
    */
    //useItineraryStore().googlemapsDirectionsLink = createGoogleMapsLink(useItineraryStore().itinerary[useItineraryStore().selectedPath],currentCoordinate.value, useItineraryStore().travelMode);


    useItineraryStore().blockNavigation = false;
}

function returnMarkerScale(scale05,scale15) {
  let scale0_5 = scale05;
  let scale1_5 = scale15;

  if(windowWidth <= 1920) {
    scale0_5 = scale0_5 / 2;
    scale1_5  = scale1_5 / 2;
  }
  return [
    'interpolate',
    ['linear'],
    ['zoom'],
    0, scale0_5,
    22, scale1_5
  ]
}

const setupClusterSource = () => {
  let itinerary = useItineraryStore().itinerary;
  let firstKey = Object.keys(itinerary)[useItineraryStore().selectedPathNumber];
  let firstProperty = itinerary[firstKey];
  let selectedPathData = useItineraryStore().itinerary[useItineraryStore().selectedPath];
  if(firstKey == undefined) {
   return;
  }

  let startingPoint = {
    type: 'Feature',
    geometry: {type: 'Point',coordinates: selectedPathData.route.geometry.coordinates[0]},          
    properties: {categories: ['current','location']}
  };

  let poisCopy = [...firstProperty.pois];
  poisCopy.unshift(startingPoint);
 
  let clusters = {
    type: "FeatureCollection",
    features:  poisCopy
  }
  if (useItineraryStore().map.getSource('clustering')) {
    useItineraryStore().map.getSource('clustering').setData(clusters);
    loadMarkersToMap(loadFirst);
    showPath();
  }else {
    useItineraryStore().map.addSource('clustering', {
        'type': 'geojson',
        'data': clusters,
        'cluster': false,
        //clusterMaxZoom: 16,
        clusterRadius: 80,
        clusterProperties: {
            'hasOpaqueMarker': ['any', ['get', 'hasOpaqueMarker']]
        }
    });
    loadMapMarkersAndLayers();
  }
  
  //useItineraryStore().googlemapsDirectionsLink = createGoogleMapsLink(selectedPathData,currentCoordinate.value);
};


function readJSONAsync(url) {
  return new Promise((resolve, reject) => {
    readJSON(url, result => {
      resolve(result);
    });
    // Consider adding error handling here
  });
}

//for qr code
watch(
    () => useItineraryStore().itinerary,
    (newValue,oldValue) => {
      let allKeys = Object.keys(oldValue);
      // if the itinerary is empty means its on load
      console.log("watcher itinerary");
      if(allKeys.length == 0) {
        if(useItineraryStore().map == null) {
          console.log("is null")
          return;
        }
        
        if (mapLoaded.value == true) {
        //if app was first loaded without any data
          console.log("first qr code");
          setData().then(() => {
            
          });
        }
      }else {
        //when new data is loaded from qr code and the itinerary is not empty it has to delete current path from map
        /*
        console.log("new itinerary");
        if (useItineraryStore().map.getLayer('path_' + useItineraryStore().allKeys[useItineraryStore().selectedPathNumber])) {
          console.log("remove Layer");
          useItineraryStore().map.removeLayer('path_' + useItineraryStore().allKeys[useItineraryStore().selectedPathNumber]);
          useItineraryStore().map.removeSource('path_' + useItineraryStore().allKeys[useItineraryStore().selectedPathNumber]);
          setData().then(() => {
            setupClusterSource();
            setMap();
          });
        }else {
          
        }
        */
        renderMarkerLayer(useItineraryStore().selectedPathNumber);
      }
    }
  )

  function renderMarkerLayer(oldValue){
    useItineraryStore().blockNavigation = true;
      if (useItineraryStore().map.getLayer('path_' + useItineraryStore().allKeys[oldValue])) {
        console.log("remove Layer");
        useItineraryStore().map.removeLayer('path_' + useItineraryStore().allKeys[oldValue]);
        useItineraryStore().map.removeSource('path_' + useItineraryStore().allKeys[oldValue]);
        setData().then(() => {
          setMap();
          setupClusterSource();
        });
      }else {
        setMap();
        setupClusterSource();
      }
  }

  watch(
    () => useItineraryStore().categoriesMarkersDone,
    (newValue) => {
      if(newValue) {

        //drejc tke lahko šele dodajamo marker layaer

        console.log("useItineraryStore().categoriesMarkersDone", useItineraryStore().categoriesMarkersDone );
        const currentImage = useItineraryStore().markersImages.get('current-location');
        console.log("currentImage",currentImage);
            useItineraryStore().map.loadImage(currentImage, function(error, image) {
              if (error) throw error;
              useItineraryStore().map.addImage('image-marker-current-location', image);
            });
        setupClusterSource();
      }
    }
  )

  watch(
    () => useItineraryStore().selectedPathNumber,
    (newValue,oldValue) => {
      //debugger;
      console.log("selectedPathNumber", newValue);
      renderMarkerLayer(oldValue)
    }
  )
</script>

<template>
  <!--When more screens install router and make a new component-->
  <HorizontalBlocker v-if="useItineraryStore().goaway"></HorizontalBlocker>
  <div>
    <Header></Header>
    <SideBar ref="sidebarRef"></SideBar>
    <PoiCard v-show="useItineraryStore().activePoi !== null"></PoiCard>
    <QrCamera v-if="useItineraryStore().showCamera"></QrCamera>
    <div id="map" style="width: 100vw; height: 100vh; right:0; top:0;"></div>
  </div>
</template>

<style>
  @import '@/assets/styles/styles.scss';
</style>
<style scoped>

.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
